import { render, staticRenderFns } from "./SupplierBadge.vue?vue&type=template&id=63beca93"
import script from "./SupplierBadge.vue?vue&type=script&lang=js"
export * from "./SupplierBadge.vue?vue&type=script&lang=js"
import style0 from "./SupplierBadge.vue?vue&type=style&index=0&id=63beca93&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports